import React from 'react';
import { cn } from '@/lib/utils';

interface SectionCardProps {
  title?: string;
  description?: React.ReactNode;
  children: React.ReactNode;
  showDividers?: boolean; // Divisores suaves entre itens
  className?: string;
  /** Versão de menor respiro, para seções aninhadas dentro de outra. */
  compact?: boolean;
}

/**
 * Bloco de configuração do editor de vídeo.
 *
 * Card branco flutuando sobre o fundo cinza do painel (ver SideBySideEditor):
 * é a sombra + o contraste com o fundo que separam uma seção da outra.
 * Usado por todas as configurações de recurso do "Personalizar".
 */
export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  description,
  children,
  showDividers = false,
  className,
  compact = false,
}) => {
  const hasHeader = !!title || !!description;

  return (
    <div
      className={cn(
        "bg-white rounded-[14px] border border-[#E5E7EB]",
        "shadow-[0_2px_8px_rgba(15,23,42,0.05)]",
        compact ? "p-3" : "p-[18px]",
        "transition-all duration-200",
        "hover:border-[#D0D5DD] hover:shadow-[0_4px_14px_rgba(15,23,42,0.07)]",
        className
      )}
    >
      {hasHeader && (
        <div>
          {title && (
            <h3 className={cn(
              "font-semibold text-[#0F172A]",
              compact ? "text-[12px]" : "text-[13px]"
            )}>
              {title}
            </h3>
          )}
          {description && (
            <p className={cn(
              "text-[#64748B] mt-0.5",
              compact ? "text-[10.5px]" : "text-[11px]"
            )}>
              {description}
            </p>
          )}
        </div>
      )}

      <div className={cn(
        hasHeader && (compact ? "mt-2" : "mt-[14px]"),
        showDividers && "[&>*:not(:last-child)]:border-b [&>*:not(:last-child)]:border-[#E5E7EB] [&>*:not(:last-child)]:pb-0.5"
      )}>
        {children}
      </div>
    </div>
  );
};
